import * as React from 'react';
import {Redirect} from 'react-router-dom';

import {ListPageRoute} from './list-page-route';
import type {Props as ListPageRouteProps} from './list-page-route';

type Props = ListPageRouteProps & {
    hasAccess: boolean;
    redirectPath: string;
};

export const RestrictedListPageRoute = (props: Props) => {
    const {hasAccess, redirectPath, ...listPageRouteProps} = props;

    return (
        <>
            {hasAccess ? <ListPageRoute {...listPageRouteProps} /> : <Redirect to={redirectPath} />}
        </>
    );
};
